/* unplugin-vue-components disabled */import { render } from "./AnswerHistoryView.vue?vue&type=template&id=2749ea20&scoped=true"
import script from "./AnswerHistoryView.vue?vue&type=script&lang=js"
export * from "./AnswerHistoryView.vue?vue&type=script&lang=js"

import "./AnswerHistoryView.vue?vue&type=style&index=0&id=2749ea20&lang=scss&scoped=true"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2749ea20"]])

export default __exports__